var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMicrophoneEmpty = function SvgMicrophoneEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6a4 4 0 0 0-8 0v6a4.002 4.002 0 0 0 3.008 3.876c-.005.04-.008.082-.008.124v1.917A6.002 6.002 0 0 1 6 12a1 1 0 1 0-2 0 8.001 8.001 0 0 0 7 7.938V21a1 1 0 1 0 2 0v-1.062A8.001 8.001 0 0 0 20 12a1 1 0 1 0-2 0 6.002 6.002 0 0 1-5 5.917V16c0-.042-.003-.083-.008-.124A4.002 4.002 0 0 0 16 12V6Zm-4-2a2 2 0 0 0-2 2v6a2 2 0 1 0 4 0V6a2 2 0 0 0-2-2Z"
  })));
};

export default SvgMicrophoneEmpty;